// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AddRoom_wrapper__3k-hh","btn_add_team":"AddRoom_btn_add_team__HbjgN","btn_save":"AddRoom_btn_save__2fZQY"};